module.exports = "/_next/static/images/RVO-1f6f1c20d62a7a8b73649ea5619be979.svg";